import { Stack, Box, Group, SimpleGrid } from "@mantine/core";
import useWindowDimensions from "../../hooks/WindowSize";
import Stat from "./Stat";

export default function FactsList(props) {
  const { height, width } = useWindowDimensions();
  if (width > 800) {
    return (
      <Group
        position="apart"
        spacing="28px"
        grow
        sx={{ display: "flex", alignItems: "stretch" }}
      >
        {props.objects.map((thisFact, idx) => {
          if (thisFact && thisFact.title && thisFact.logo && thisFact.content) {
            return (
              <Box
                key={"thisFact-" + idx}
                sx={{
                  backgroundColor: "#222629",
                  borderRadius: "7px",
                  padding: "28px",
                  flex: 1,
                }}
              >
                <Stat
                  title={thisFact.title}
                  logo={thisFact.logo}
                  content={thisFact.content}
                  description={thisFact.description}
                  key={idx + thisFact.title}
                />
              </Box>
            );
          } else {
            return <Stack />;
          }
        })}
      </Group>
    );
  } else {
    return (
      <SimpleGrid cols={2} spacing={28} verticalSpacing={28}>
        {props.objects.map((thisFact, idx) => {
          if (thisFact && thisFact.title && thisFact.logo && thisFact.content) {
            return (
              <Box
                key={"thisFact-" + idx}
                sx={{
                  backgroundColor: "#222629",
                  borderRadius: "7px",
                  padding: "28px",
                  flex: 1,
                }}
              >
                <Stat
                  title={thisFact.title}
                  logo={thisFact.logo}
                  content={thisFact.content}
                  description={thisFact.description}
                  key={idx + thisFact.title}
                  small={true}
                />
              </Box>
            );
          } else {
            return <Stack />;
          }
        })}
      </SimpleGrid>
    );
  }
}
